import { createSelector } from "reselect";

const getPopularSelector = state => {
  return state.popular.moviesPopular;
};

export const getPopular = createSelector(getPopularSelector, moviesPopular => {
  return moviesPopular;
});
